// extracted by mini-css-extract-plugin
export var ExternalLink = "cta-product-module--ExternalLink--2fb0c";
export var ExternalLinkImageWrapper = "cta-product-module--ExternalLinkImageWrapper--4ec03";
export var SideColumnText = "cta-product-module--SideColumnText--14002";
export var SideColumnTitle = "cta-product-module--SideColumnTitle--cd6f0";
export var body = "cta-product-module--body--8677d";